var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"main pb-0"},[_c('b-row',{staticClass:"vh-100"},[_c('b-col',{staticClass:"my-auto",attrs:{"offset-md":"2","offset-lg":"3","md":"8","lg":"6"}},[(_vm.showLoading)?_c('LoadingComponent'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }